import { Link } from "react-router-dom";
import styled from "styled-components";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import { useCaseContext } from "@/Features";
import { evidenceDetailPath } from "@/Features/Evidence/evidenceLinks";

const EvidenceNumberCell = styled(({ className, rowData, color }) => {
  const caseContext = useCaseContext();

  if (!rowData?.uuid) {
    return null;
  }
  return (
    <Link
      className={className}
      to={evidenceDetailPath(rowData.uuid, {
        caseId: caseContext?.data?.case_id,
      })}
    >
      <div
        style={{
          display: "flex",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <div>{rowData.evidence_number}</div>
        <LaunchOutlinedIcon
          className="action-button"
          style={{ fontSize: 13, marginLeft: 5 }}
        />
      </div>
    </Link>
  );
})(({ theme, rowData, color }) => ({
  color: color
    ? color
    : rowData.is_parent === 1
    ? theme.palette.primary.main
    : theme.palette.warning.main,
  // hover
  "&:hover": {
    textDecoration: "underline",
  },
}));

export default EvidenceNumberCell;
